"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorWebOriginationStatus = void 0;
var AvenAdvisorWebOriginationStatus;
(function (AvenAdvisorWebOriginationStatus) {
    AvenAdvisorWebOriginationStatus["notApplicable"] = "notApplicable";
    AvenAdvisorWebOriginationStatus["onboardingOnWeb"] = "onboardingOnWeb";
    AvenAdvisorWebOriginationStatus["convertedOnNative"] = "convertedOnNative";
})(AvenAdvisorWebOriginationStatus || (exports.AvenAdvisorWebOriginationStatus = AvenAdvisorWebOriginationStatus = {}));
